import { captureAcquisition } from "./app/shared/helpers/acquisition.helper";
import { patchPrimeNgTreeTableRow } from "./app/shared/helpers/primeng-ttrow.patch";
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// ASCII banner — browser console
console.log(
  `%c
  ███████╗██╗   ██╗ █████╗     ██╗████████╗
  ██╔════╝██║   ██║██╔══██╗    ██║╚══██╔══╝
  █████╗  ██║   ██║███████║    ██║   ██║
  ██╔══╝  ╚██╗ ██╔╝██╔══██║    ██║   ██║
  ███████╗ ╚████╔╝ ██║  ██║    ██║   ██║
  ╚══════╝  ╚═══╝  ╚═╝  ╚═╝    ╚═╝   ╚═╝
%c  ▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀
  F R O N T E N D
%c
  ██████████████
  ██████████████
  █████▒▒▒▒█████
  █████▒▒▒▒█████
  ██▒▒▒▒▒▒▒▒▒▒██
  ██▒▒▒▒▒▒▒▒▒▒██
  █████▒▒▒▒█████
  █████▒▒▒▒█████
  ██████████████
  ██████████████
                    Made in Switzerland
%c
  Version  v${environment.appVersion}
  Env      ${environment.env}
`,
  "color: #4caf50; font-family: monospace; font-size: 12px;",
  "color: #42a5f5; font-family: monospace; font-size: 12px;",
  "color: #ff0000; font-family: monospace; font-size: 12px; font-weight: bold;",
  "color: #ffc107; font-family: monospace; font-size: 11px;",
);

if (environment.production) {
  enableProdMode();

  if (["PROD-V3", "NEXT-V3"].includes(environment.env)) {
    Sentry.init({
      dsn: "https://e360c7a5df83bd937b1380378ca5bd6b@o4510951868071936.ingest.de.sentry.io/4510952386527312",
      environment: environment.env,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Chunk loading errors : filtrées ici car le SDK Sentry les capture via unhandledrejection
      // AVANT que Angular/GlobalErrorHandler puisse les intercepter. L'UX est gérée par
      // handleChunkLoadError() (auto-reload avec anti-boucle). Voir Sentry #7265522598.
      ignoreErrors: [
        /Loading chunk \d+ failed/,
        /Failed to fetch dynamically imported module/,
        /Failed to load module script/,
      ],
      debug: false,
      release: "eva-front@" + environment.appVersion,
      tracesSampleRate: 0.1,
      tracePropagationTargets: [environment.apiUrl],
      profilesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 0.1,
      maxBreadcrumbs: 50,
      enableLogs: true,
    });
  } else if (environment.env === "STG-V3") {
    Sentry.init({
      dsn: "https://e360c7a5df83bd937b1380378ca5bd6b@o4510951868071936.ingest.de.sentry.io/4510952386527312",
      environment: environment.env,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Chunk loading errors : filtrées ici car le SDK Sentry les capture via unhandledrejection
      // AVANT que Angular/GlobalErrorHandler puisse les intercepter. L'UX est gérée par
      // handleChunkLoadError() (auto-reload avec anti-boucle). Voir Sentry #7265522598.
      ignoreErrors: [
        /Loading chunk \d+ failed/,
        /Failed to fetch dynamically imported module/,
        /Failed to load module script/,
      ],
      debug: false,
      release: "eva-front@" + environment.appVersion,
      tracesSampleRate: 1.0,
      tracePropagationTargets: [environment.apiUrl],
      profilesSampleRate: 1.0,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      maxBreadcrumbs: 50,
      sendDefaultPii: true,
      enableLogs: true,
    });
  }
}

if (!environment.enableDebug) {
  console.debug = () => {};
}

captureAcquisition();
patchPrimeNgTreeTableRow();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
